import LogoutButton from '@/components/ProfileDropdown/LogoutButton';
import { Image, StaggerAnimation } from '@starsoft/common/components';
import ProfileDrawerContentBalance from './Balance';
import ProfileDrawerContentHeader from './Header';
import ProfileDrawerContentNavigation from './Navigation/Common';
import ProfileDrawerContentNavigationSettings from './Navigation/Settings';
import ProfileDrawerContentReferAndEarn from './ReferAndEarn';
import styles from './styles.module.scss';
import SupportSection from './Support';

export default function ProfileDrawerContent() {
  return (
    <div className={styles.container}>
      <div className={styles.container__image__wrapper}>
        <Image
          src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/earnings/1.png`}
          alt="earnings"
          width={100}
          height={100}
          className={styles.container__image}
        />
      </div>
      <ProfileDrawerContentHeader />
      <StaggerAnimation
        direction="column"
        stagger={0.15}
        staggerDirection="up"
        className={styles.container__content}
      >
        <ProfileDrawerContentBalance />
        <ProfileDrawerContentNavigation />
        <ProfileDrawerContentReferAndEarn />
        <ProfileDrawerContentNavigationSettings />
        <SupportSection />
        <LogoutButton />
      </StaggerAnimation>
    </div>
  );
}
